interface Props {
  message: string
}

export default function HintBar({ message }: Props) {
  if (!message) return null

  return (
    <div style={{
      padding: '6px 12px',
      fontSize: '0.8125rem',
      color: 'var(--color-text-secondary)',
      background: 'var(--color-bg-secondary)',
      borderTop: '1px solid var(--color-border)',
      textAlign: 'center',
      flexShrink: 0,
    }}>
      {message}
    </div>
  )
}
